import axios from "@/api/interceptor";

// 充值
export function getFinanceRecharge(params: any) {
  return axios.get("/agent/finances/recharge", { params });
}

// 充值统计
export function getFinanceRechargeTotal(params: any) {
  return axios.get("/agent/finances/recharge-total", { params });
}

// 退款
export function getFinanceRefund(params: any) {
  return axios.get("/agent/finances/refund", { params });
}

// 退款统计
export function getFinanceRefundTotal(params: any) {
  return axios.get("/agent/finances/refund-total", { params });
}

// 扣费
export function getFinanceDeduction(params: any) {
  return axios.get("/agent/finances/deduction", { params });
}

// 扣费统计
export function getFinanceDeductionTotal(params: any) {
  return axios.get("/agent/finances/deduction-total", { params });
}

// 二代充值
export function getFinanceAgent2Recharge(params: any) {
  return axios.get("/agent/finances/agent2-recharge", { params });
}

// 二代充值统计
export function getFinanceAgent2RechargeTotal(params: any) {
  return axios.get("/agent/finances/agent2-recharge-total", { params });
}

// 二代退款
export function getFinanceAgent2Refund(params: any) {
  return axios.get("/agent/finances/agent2-refund", { params });
}

// 二代退款统计
export function getFinanceAgent2RefundTotal(params: any) {
  return axios.get("/agent/finances/agent2-refund-total", { params });
}

// 直客充值
export function getFinanceClientRecharge(params: any) {
  return axios.get("/agent/finances/client-recharge", { params });
}

// 直客充值统计
export function getFinanceClientRechargeTotal(params: any) {
  return axios.get("/agent/finances/client-recharge-total", { params });
}

// 直客退款
export function getFinanceClientRefund(params: any) {
  return axios.get("/agent/finances/client-refund", { params });
}

// 直客退款统计
export function getFinanceClientRefundTotal(params: any) {
  return axios.get("/agent/finances/client-refund-total", { params });
}

// 二级代理/充值 
export function postPaySecondAgent(data: any) {
  return axios.post("/agent/finances/agent-recharge", data);
}

// 直客/充值 
export function postPayClient(data: any) {
  return axios.post("/agent/finances/client-recharge", data);
}